// import { shallowEqual, useSelector } from "react-redux";
import { API_END_POINTS } from "../../constant/config";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { LOG_OUT } from "../type";


// Login
export function login(email, password) {
    const apiEndpoint = API_END_POINTS.LOGIN_URL;
    // console.log(apiEndpoint,"apiEndpoint")
    return JsonInterceptor.post(apiEndpoint, { email, password });
   
}

// export const loadUser = () => async (dispatch) => {
//     try {
//         const apiEndpoint = API_END_POINTS.LOGIN_URL;
        
//       const res = await JsonInterceptor.get(ME_URL);
  
//       if (res === "Unauthorized") {
//         localStorage.clear();
//       }
//       dispatch({
//         type: USER_LOADED,
//         payload: res.data,
//       });
//     } catch (err) {
//       dispatch({
//         type: LOAD_FAILED,
//       });
//     }
//   };

export const logout = (data, id) => async (dispatch) => {
    try {
      dispatch({
        type: LOG_OUT,
      });
    } catch (error) {
      console.log("error", error);
    }
  };

export const getAccessToken = (accessToken) =>
{
    const token =accessToken ;
    console.log(token)
      return token ;

}
